<!--
    课件-双师课件管理
    作用：展示双师课件列表数据、擎想系统预览权限、根据学科/目录筛选数据
    组件:AppList、AppSearch
-->
<template>
  <div class="role" v-loading="loading">
    <AppList
      ref="list"
      :list.sync="list"
      title=""
      api="/api/imkid/course_manage">
      <AppSearch
        slot="search"
        :order="{ type: 'id', name: 'desc'}"
        :search-arr="searchArr"/>
      <template slot-scope="props">
        <el-table :data="props.listData" tooltip-effect="dark">
<!--          <el-table-column type="selection" @selection-change="handleSelectionChange"></el-table-column>-->
          <el-table-column
            v-for="column in columns"
            v-if="!column.show"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :formatter="column.formatter"
          />
          <el-table-column
            label="预览"
            width="300px"
          >
            <template slot-scope="scope">
              <el-switch v-model="scope.row.preview === 1" @change="getPreview(scope.row)"></el-switch>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </AppList>
  </div>
</template>

<script>
  export default {
    name: "manageYun",
    inject: ['reload'],
    data() {
      return {
        loading: false,
        list: {},
        multipleSelection: [],
        columns: [
          { prop: 'name', label: '课件名称' },
          { prop: 'title', label: '课件标题' },
          { prop: 'category_name', label: '所属分类' },
          { prop: 'type', label: '课件类型', formatter: row => {
              switch (row.type) {
                case 'online': return '线上课件'; break;
                case 'offline': return '线下课件'; break;
                case 'double_teacher': return '双师课件'; break;
              }
            }},
          { prop: 'created_at', label: '创建时间' },
          { prop: 'updated_at', label: '更新时间' },
          { prop: 'package_status', label: '发布状态', formatter: row => {
              switch (row.package_status) {
                case 'unpublished': return '未发布'; break;
                case 'success': return '发布成功'; break;
                case 'failure': return '发布失败'; break;
                default: return '未发布'
              }
            } },
          { prop: 'school_name', label: '校区名称' },
          { prop: 'create_name', label: '创建人' },
          { prop: 'mobile', label: '手机号' },
          { prop: 'update_name', label: '最后修改', formatter: row => row.update_name || '--' }
        ],
      }
    },
    methods: {
      getPreview (row) {
        this.loading = true;

        this.$http.patch(`/api/course/result/${row.id}`, {
          preview: row.preview ? 0 : 1
        }).then(() => {
          this.reload();
        }).finally(() => {
          this.loading = false;
        })
      },

      handleSelectionChange(val) {
        this.multipleSelection = val;
      }
    },
    computed: {
      searchArr() {
        return [
          {
            selectValue: [

              {
                value: 1,
                name: '发布失败'
              },
              {
                value: 2,
                name: '发布成功'
              },
              {
                value: 3,
                name: '未发布'
              }
            ],
            componentType: 'AppSearchStatus',
            searchType: 'package_status',
            placeholder: '发布状态'
          },
          {
            componentType: 'AppSearchDate',
            searchType: [
              {
                name: '创建时间',
                type: 'result@created_at'
              },
              {
                name: '更新时间',
                type: 'result@updated_at'
              }
            ],
          },
          {
            componentType: 'AppSearchColumn',
            searchType: [
              { prop: 'result@name', label: '课件名称' },
              { prop: 'result@title', label: '课件标题' },
              { prop: 'category@name', label: '所属分类' },
              { prop: 'school@name', label: '校区名称' },
              { prop: 'users@mobile', label: '手机号' },
              { prop: 'users@name', label: '创建人' },
            ]
          },
        ];
      },
    }
  }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/Courseware/manageYun/index.vue